var map = {
	"./articles-carousel": [
		"./src/js/modules/articles-carousel.js",
		[
			"swiper",
			"articles-carousel"
		]
	],
	"./articles-carousel.js": [
		"./src/js/modules/articles-carousel.js",
		[
			"swiper",
			"articles-carousel"
		]
	],
	"./attorney-referral-swiper": [
		"./src/js/modules/attorney-referral-swiper.js",
		[
			"swiper",
			"attorney-referral-swiper"
		]
	],
	"./attorney-referral-swiper.js": [
		"./src/js/modules/attorney-referral-swiper.js",
		[
			"swiper",
			"attorney-referral-swiper"
		]
	],
	"./awards-carousel": [
		"./src/js/modules/awards-carousel.js",
		[
			"swiper",
			"awards-carousel"
		]
	],
	"./awards-carousel-sidebar": [
		"./src/js/modules/awards-carousel-sidebar.js",
		[
			"swiper",
			"awards-carousel-sidebar"
		]
	],
	"./awards-carousel-sidebar.js": [
		"./src/js/modules/awards-carousel-sidebar.js",
		[
			"swiper",
			"awards-carousel-sidebar"
		]
	],
	"./awards-carousel.js": [
		"./src/js/modules/awards-carousel.js",
		[
			"swiper",
			"awards-carousel"
		]
	],
	"./banner-carousel-slider": [
		"./src/js/modules/banner-carousel-slider.js",
		[
			"swiper",
			"banner-carousel-slider"
		]
	],
	"./banner-carousel-slider.js": [
		"./src/js/modules/banner-carousel-slider.js",
		[
			"swiper",
			"banner-carousel-slider"
		]
	],
	"./choose-us-carousel": [
		"./src/js/modules/choose-us-carousel.js",
		[
			"swiper",
			"choose-us-carousel"
		]
	],
	"./choose-us-carousel.js": [
		"./src/js/modules/choose-us-carousel.js",
		[
			"swiper",
			"choose-us-carousel"
		]
	],
	"./news-carousel": [
		"./src/js/modules/news-carousel.js",
		[
			"swiper",
			"news-carousel"
		]
	],
	"./news-carousel.js": [
		"./src/js/modules/news-carousel.js",
		[
			"swiper",
			"news-carousel"
		]
	],
	"./recognitions-carousel-sidebar": [
		"./src/js/modules/recognitions-carousel-sidebar.js",
		[
			"swiper",
			"recognitions-carousel-sidebar"
		]
	],
	"./recognitions-carousel-sidebar.js": [
		"./src/js/modules/recognitions-carousel-sidebar.js",
		[
			"swiper",
			"recognitions-carousel-sidebar"
		]
	],
	"./results-carousel": [
		"./src/js/modules/results-carousel.js",
		[
			"swiper",
			"results-carousel"
		]
	],
	"./results-carousel-pa": [
		"./src/js/modules/results-carousel-pa.js",
		[
			"swiper",
			"results-carousel-pa"
		]
	],
	"./results-carousel-pa.js": [
		"./src/js/modules/results-carousel-pa.js",
		[
			"swiper",
			"results-carousel-pa"
		]
	],
	"./results-carousel.js": [
		"./src/js/modules/results-carousel.js",
		[
			"swiper",
			"results-carousel"
		]
	],
	"./results-slider-sidebar": [
		"./src/js/modules/results-slider-sidebar.js",
		[
			"swiper",
			"results-slider-sidebar"
		]
	],
	"./results-slider-sidebar.js": [
		"./src/js/modules/results-slider-sidebar.js",
		[
			"swiper",
			"results-slider-sidebar"
		]
	],
	"./table-of-contents": [
		"./src/js/modules/table-of-contents.js",
		[
			"table-of-contents"
		]
	],
	"./table-of-contents.js": [
		"./src/js/modules/table-of-contents.js",
		[
			"table-of-contents-js"
		]
	],
	"./team-carousel": [
		"./src/js/modules/team-carousel.js",
		[
			"swiper",
			"team-carousel"
		]
	],
	"./team-carousel.js": [
		"./src/js/modules/team-carousel.js",
		[
			"swiper",
			"team-carousel"
		]
	],
	"./team-sidebar-widget": [
		"./src/js/modules/team-sidebar-widget.js",
		[
			"swiper",
			"team-sidebar-widget"
		]
	],
	"./team-sidebar-widget.js": [
		"./src/js/modules/team-sidebar-widget.js",
		[
			"swiper",
			"team-sidebar-widget"
		]
	],
	"./testimonials-carousel": [
		"./src/js/modules/testimonials-carousel.js",
		[
			"swiper",
			"testimonials-carousel"
		]
	],
	"./testimonials-carousel.js": [
		"./src/js/modules/testimonials-carousel.js",
		[
			"swiper",
			"testimonials-carousel"
		]
	],
	"./testimonials-sidebar": [
		"./src/js/modules/testimonials-sidebar.js",
		[
			"swiper",
			"testimonials-sidebar"
		]
	],
	"./testimonials-sidebar.js": [
		"./src/js/modules/testimonials-sidebar.js",
		[
			"swiper",
			"testimonials-sidebar"
		]
	],
	"./videos-carousel": [
		"./src/js/modules/videos-carousel.js",
		[
			"swiper",
			"videos-carousel"
		]
	],
	"./videos-carousel.js": [
		"./src/js/modules/videos-carousel.js",
		[
			"swiper",
			"videos-carousel"
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/js/modules lazy recursive ^\\.\\/.*$ referencedExports: ";
module.exports = webpackAsyncContext;